import React, { useEffect, useState } from "react";
import { TextField, MenuItem } from "@mui/material";
import { useAppSelector } from "../../../../../app/hooks";
import { defaultTicketTypeConfig, TicketTypeConfig } from "../../../../../services/ticketEasyService/model/ticketEasy/ticketTypeConfig/TicketTypeConfig";

interface TicketTypeDropdownProps {
  ticketTypeConfigList: TicketTypeConfig[];
  handleTicketTypeSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedModule: string;
}

function TicketTypeDropdown({ ticketTypeConfigList, handleTicketTypeSelect, selectedModule }: TicketTypeDropdownProps) {
  const ticketTypeConfigState = useAppSelector((state) => state.ticketTypeConfig.ticketTypeConfig);
  const [ticketConfig, setTicketConfig] = useState<TicketTypeConfig>(defaultTicketTypeConfig());

  useEffect(() => {
    setTicketConfig(ticketTypeConfigState);
  }, [ticketTypeConfigState]);

  return (
    <TextField
      select
      label="Ticket Type"
      name="ticketTypeConfig"
      value={ticketConfig.ticketType}
      onChange={handleTicketTypeSelect}
      disabled={!selectedModule}
      required
      fullWidth
    >
      {ticketTypeConfigList.map((ticketTypeConfig) => (
        <MenuItem key={ticketTypeConfig.id} value={ticketTypeConfig.ticketType}>
          {ticketTypeConfig.ticketType}
        </MenuItem>
      ))}
    </TextField>
  );
}

export { TicketTypeDropdown };
